var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoCentreMapIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#BA0229"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.009 8.24023C10.9561 8.24023 5.2981 18.0402 9.82453 25.8802C14.351 33.7202 25.667 33.7202 30.1934 25.8802C31.2256 24.0925 31.769 22.0645 31.769 20.0002C31.7621 13.5082 26.501 8.2471 20.009 8.24023ZM20.009 29.951C12.3489 29.9513 7.56139 21.6593 11.3912 15.0252C15.2209 8.39122 24.796 8.39079 28.6264 15.0245C29.4999 16.5373 29.9598 18.2534 29.9598 20.0002C29.9535 25.4933 25.5021 29.9448 20.009 29.951ZM21.8182 25.4279C21.8182 25.9275 21.4132 26.3325 20.9136 26.3325C19.9144 26.3326 19.1044 25.5226 19.1044 24.5233V20.0002C18.408 20.0002 17.9728 19.2464 18.321 18.6433C18.4825 18.3634 18.7812 18.191 19.1044 18.191C20.1036 18.191 20.9136 19.001 20.9136 20.0002V24.5233C21.4132 24.5233 21.8182 24.9283 21.8182 25.4279ZM18.1998 15.0248C18.1998 13.9803 19.3305 13.3274 20.2351 13.8497C21.1398 14.372 21.1398 15.6777 20.2351 16.2C20.0289 16.3191 19.7949 16.3818 19.5567 16.3818C18.8072 16.3818 18.1998 15.7743 18.1998 15.0248Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCentreMapIcon);
export default __webpack_public_path__ + "static/media/info-centre-map-icon.988044b5b07559d5b48109c20da61fc7.svg";
export { ForwardRef as ReactComponent };